export default "__VITE_ASSET__3coj1GuN__"